import type { IntlShape } from 'react-intl';
import { Link } from 'react-router';

import type { InvoiceType } from '@/api/schema';
import Money from '@/components/Money';
import type { Column } from '@/components/Table/Table';
import { formatDateLocalized } from '@/lib/utils';

export const columns = (intl: IntlShape, currency: string, locale: string): Column<InvoiceType>[] => [
    {
        key: 'issueDate',
        label: intl.formatMessage({ id: 'invoices.issueDate' }),
        valueGetter: originalRow => originalRow.issueDate,
        renderCell: ({ row }) => <span>{formatDateLocalized(new Date(row.issueDate!), locale)}</span>,
        sortable: true,
    },
    {
        key: 'dueDate',
        label: intl.formatMessage({ id: 'invoices.dueDate' }),
        valueGetter: originalRow => originalRow.dueDate,
        renderCell: ({ row }) => <span>{formatDateLocalized(new Date(row.dueDate!), locale)}</span>,
        sortable: true,
    },
    {
        key: 'invoiceNumber',
        label: intl.formatMessage({ id: 'invoices.invoiceNumber' }),
        valueGetter: originalRow => originalRow.invoiceNumber,
        renderCell: ({ row }) => <span>{row.invoiceNumber}</span>,
        sortable: true,
    },
    {
        key: 'totalCost',
        label: intl.formatMessage({ id: 'general.costGross' }),
        valueGetter: originalRow => originalRow.totalCost,
        renderCell: ({ row }) => <Money currency={currency} value={row.totalCost ?? 0} />,
        sortable: true,
    },
    {
        key: 'action',
        label: '',
        valueGetter: () => {},
        renderCell: ({ row }) => {
            if (row.downloadLink) {
                return (
                    <div className='display-flex justify-content-end'>
                        <Link
                            data-testid='downloadInvoice'
                            to={row.downloadLink}
                            download={`${row.invoiceNumber}.pdf`}
                            className='text-color-primary btn-link'
                            target='_blank'
                        >
                            <span className='rioglyph rioglyph-new-window' aria-hidden='true' />{' '}
                            {intl.formatMessage({ id: 'invoices.button.downloadPdf' })}
                        </Link>
                    </div>
                );
            }
            return null;
        },
    },
];
